import { Blocks } from "lucide-react";
import type { FC } from "react";
import React from "react";

interface AppLogoProps {
  readonly title: string;
}

export const AppLogo: FC<AppLogoProps> = ({ title }) => (
  <div className="flex items-center gap-2">
    <div className="flex size-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
      <Blocks className="size-4" />
    </div>
    <span
      className={`
        hidden text-sm font-semibold tracking-tight text-header-foreground
        sm:block
      `}
    >
      {title}
    </span>
  </div>
);
